<template>
  <div class="component-integration-card h-100">
    <div class="integration-card">
      <div class="d-flex gap-3">
        <div class="d-flex align-items-center mb-3">
          <img :src="image" alt="integração" />
        </div>

        <div class="d-flex flex-column gap-2">
          <span>{{ integration.title }}</span>
          <div
            class="d-flex justify-content-between justify-content-lg-start align-items-start gap-3"
          >
            <span
              v-if="integration.description"
              class="functional-1 text-neutral-400"
            >
              {{ integration.description }}
            </span>
            <bp-button
              v-if="integration.link"
              size="sm"
              variant="glyph"
              icon="fa-regular fa-arrow-up-right-from-square"
              @click="openLink"
            />
          </div>
        </div>
      </div>

      <div
        v-if="integration.modal"
        class="d-flex flex-column flex-lg-row gap-5 mt-5 justify-content-lg-end"
      >
        <bp-button
          size="sm"
          label="Integrar"
          variant="outlined"
          class="order-0 order-lg-1"
          @click="integrate"
        />

        <bp-button
          size="sm"
          color="neutral"
          variant="glyph"
          label="Visualizar"
          @click="goToIntegration"
        />
      </div>

      <div v-else class="mt-5 text-right text-primary-700 functional-1 p-2">
        Em breve
      </div>

      <div class="mt-5" v-if="$slots['extra-buttons']">
        <slot name="extra-buttons" />
      </div>
    </div>

    <integration-modal
      v-if="newModal"
      v-model="modal"
      :link="integration.link"
      :content="integration.modal"
      :title="integration.title"
    />
    <component v-else v-model="modal" :is="integration.modal" />
  </div>
</template>
<script>
import slugify from "slugify";
import IntegrationModal from "./IntegrationModal.vue";
export default {
  components: { IntegrationModal },
  data() {
    return {
      modal: false
    };
  },
  props: {
    integration: {
      type: Object,
      default: () => ({})
    },
    newModal: Boolean
  },
  methods: {
    goToIntegration() {
      this.$router.push({
        name: `tools-${slugify(this.integration.title.toLowerCase())}`
      });
    },
    integrate() {
      this.$store.commit("integration/setIntegration", this.integration.name);
      this.modal = true;
    },
    openLink() {
      window.open(this.integration.link, "_blank");
    }
  },
  computed: {
    image() {
      return (
        this.integration.image ||
        require("@/assets/images/integrations/integration-placeholder.svg")
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.integration-card {
  height: 100%;
  padding: 20px;
  border-radius: 4px;
  border: 1px solid $neutral-100;
  background: rgba(255, 255, 255, 0.16);

  @media screen and (max-width: 991px) {
    padding: 16px;
  }
  img {
    width: 56px;
    height: 56px;
    object-fit: contain;
  }
}
</style>
